export const getUrlQuery = (key) => {
  const urlParams = new URLSearchParams(location.search)
  return urlParams.get(key) || null
}
